import axios from '../services/api.service';

export interface DeactivationSet {
  fields: string[];
  tabs: string[];
}

export interface DeactivationResponse {
  user: DeactivationSet;
  company: DeactivationSet;
}

// Reads the user-level (per project) and company-level deactivation sets for
// the active project. The frontend hides anything present in either set; only
// the user-level set is surfaced in the Reports "Deactivated" tab.
export const getDeactivation = async (): Promise<DeactivationResponse | null> => {
  try {
    const { data } = await axios.get('/projects/deactivation');
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// Replaces the user-level deactivation set for the active project. Admin-only
// on the backend; mandatory keys are rejected server-side.
export const putDeactivation = async (payload: { fields: string[]; tabs: string[] }) => {
  try {
    const { data } = await axios.put('/projects/deactivation', payload);
    return { data, err: null };
  } catch (err) {
    console.error(err);
    return { data: null, err };
  }
};
